export default "/_next/static/images/2018-1x-68fb7a1c2000271f7af05966cf90282d.png";